import $ from 'jquery';
import AjaxForm from './AjaxForm';
import info from './info';

const NAMESPACE = 'ajaxForm';
const OtherAjaxForm = $.fn.ajaxForm;

const jQueryAjaxForm = function initJQueryAjaxForm(options, ...args) {
  if (typeof options === 'string') {
    const method = options;

    if (/^_/.test(method)) {
      return false;
    } else if ((/^(get)/.test(method))) {
      const instance = this.first().data(NAMESPACE);
      if (instance && typeof instance[method] === 'function') {
        return instance[method](...args);
      }
    } else {
      return this.each(function callAjaxFormInstance() {
        const instance = $.data(this, NAMESPACE);
        if (instance && typeof instance[method] === 'function') {
          instance[method](...args);
        }
      });
    }
  }

  return this.each(function initAjaxForm() {
    if (!$(this).data(NAMESPACE)) {
      $(this).data(NAMESPACE, new AjaxForm(this, options));
    }
  });
};

$.fn.ajaxForm = jQueryAjaxForm;

$.ajaxForm = $.extend({
  setDefaults: AjaxForm.setDefaults,
  noConflict: function noConflict() {
    $.fn.ajaxForm = OtherAjaxForm;
    return jQueryAjaxForm;
  },
}, info);



// WEBPACK FOOTER //
// ./assets/js/cf-ajax-form/main.js